module.exports = __webpack_public_path__ + "static/media/people-on-route.53df4158.svg";